class BlagowoodExpandableDescription extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.content = this.querySelector('[data-expandable-content]');
    this.toggle = this.querySelector('[data-expandable-toggle]');
    this.label = this.querySelector('[data-expandable-label]');
    this.collapsedHeight = 240;

    if (!this.content || !this.toggle || !this.label) return;

    this.showMore = this.dataset.showMore;
    this.showLess = this.dataset.showLess;
    this.toggle.addEventListener('click', () => this.setExpanded(!this.hasAttribute('expanded')));

    requestAnimationFrame(() => this.refresh());

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.content);
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  refresh() {
    this.collapsedHeight = window.matchMedia('(max-width: 768px)').matches ? 220 : 240;
    const expanded = this.hasAttribute('expanded');

    if (expanded) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      return;
    }

    const needsToggle = this.content.scrollHeight > this.collapsedHeight + 1;
    this.toggleAttribute('collapsible', needsToggle);
    this.toggle.hidden = !needsToggle;
    this.content.style.maxHeight = needsToggle ? `${this.collapsedHeight}px` : 'none';
    this.toggle.setAttribute('aria-expanded', 'false');
    this.label.textContent = this.showMore;
  }

  setExpanded(expanded) {
    this.toggle.setAttribute('aria-expanded', String(expanded));
    this.label.textContent = expanded ? this.showLess : this.showMore;
    this.toggleAttribute('expanded', expanded);
    this.content.style.maxHeight = expanded ? `${this.content.scrollHeight}px` : `${this.collapsedHeight}px`;
  }
}

if (!customElements.get('blagowood-expandable-description')) {
  customElements.define('blagowood-expandable-description', BlagowoodExpandableDescription);
}




(() => {
  const addBusinessDays = (date, count) => {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let remainingDays = Number(count) || 0;

    while (remainingDays > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) remainingDays -= 1;
    }

    return result;
  };

  const formatDate = (date) => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);

  const updateShippingEstimate = (container) => {
    const select = container.querySelector('[data-shipping-zone-select]');
    const selectedOption = select?.options[select.selectedIndex];
    if (!selectedOption) return;

    const price = container.querySelector('[data-shipping-price]');
    const deliveryDate = container.querySelector('[data-shipping-delivery-date]');
    const shippingPrice = selectedOption.dataset.price || '';

    if (price) { price.textContent = shippingPrice; price.hidden = !shippingPrice; }

    const transitMin = Number.parseInt(selectedOption.dataset.transitMin, 10);
    const transitMax = Number.parseInt(selectedOption.dataset.transitMax, 10);
    const handlingMin = Number.parseInt(container.dataset.handlingMin, 10);
    const handlingMax = Number.parseInt(container.dataset.handlingMax, 10);
    const hasDateRange = [transitMin, transitMax, handlingMin, handlingMax].every(Number.isFinite) && transitMin + handlingMin > 0;

    if (!deliveryDate) return;

    if (hasDateRange) {
      const start = addBusinessDays(new Date(), transitMin + handlingMin);
      const end = addBusinessDays(new Date(), transitMax + handlingMax);
      const range = start.toDateString() === end.toDateString() ? formatDate(start) : formatDate(start) + ' – ' + formatDate(end);
      deliveryDate.textContent = ((container.dataset.deliveryPrefix || '') + range).trim();
      deliveryDate.hidden = false;
    } else {
      deliveryDate.textContent = container.dataset.deliveryFallback || '';
      deliveryDate.hidden = !deliveryDate.textContent;
    }
  };

  const initializeShippingEstimates = () => {
    document.querySelectorAll('[data-blagowood-shipping-info]').forEach((container) => {
      if (container.dataset.shippingEstimateReady === 'true') return;
      const select = container.querySelector('[data-shipping-zone-select]');
      if (!select) return;
      container.dataset.shippingEstimateReady = 'true';
      select.addEventListener('change', () => updateShippingEstimate(container));
      updateShippingEstimate(container);
    });
  };

  document.addEventListener('DOMContentLoaded', initializeShippingEstimates);
  document.addEventListener('shopify:section:load', initializeShippingEstimates);
})();
